<template lang="pug">
div
	v-data-table.nearby-table.mb-6(:items="items" :headers="headers" :mobile-breakpoint="100" hide-default-footer must-sort item-key="area.id" disable-sort :value="[items.find(item => item.area.id === selectedAreaId)]")
		template(#item="{item, isSelected, index}")
			tr(:class="{outdated: snowNotUpToDate(item.area.snowheights.updatedAt)}")
				td
					img.flag(:src="`https://static.wintersport.nl/images/flags/svg/${item.area.country.countryCode}.svg`" :alt="item.area.country.name")
					span.font-weight-bold(v-if="isSelected") {{item.area.name}}
					span(v-else)
						nuxt-link.no-wrap(:to="localePath({name: 'areas-area-snowheight', params: { area: item.area.slug }})") {{item.area.name}}
				td
					template(v-if="!isSelected") {{Math.round(item.distance)}}km
					v-tooltip( fixed bottom nudge-bottom="-45" :activator="`.nearby-table .outdated:nth-child(${index+1})`")
						span {{$t('page.areas._area.snowheight:nearby.not.up.to.date')}}
				td
					snowheight-bar(:max="maxSnow" :snowheight="item.area.snowheights.maxSnowMountain")
				td
					snowheight-bar(:max="maxSnow" :snowheight="item.area.snowheights.maxSnowValley")
				td
					v-sheet.label.text-center.font-weight-bold(dark max-width="70" :color="item.area.snowheights.elevatorsOpen > 0 ? 'success' : 'error'" ) {{item.area.snowheights.elevatorsOpen}}/{{item.area.snowheights.elevatorsTotal}}
	.text-center
		v-btn(color="primary" outlined :to="localePath({name: 'weather-snowheight'})") {{$t('page.areas._area.snowheight:nearby.more')}}

</template>

<style lang="sass">
.nearby-table
	.outdated
		opacity: 0.4
</style>

<script>
import gql from 'graphql-tag';
import SnowheightBar from '@/components/snowheight-bar.vue';

const nearbyQuery = gql`
	query getAreaNearbySnowheight($coordinates: Coordinates!) {
		geoInRadius(radius: 20, coordinates: $coordinates, types: ["area"]) {
			distance
			area: item {
				... on Area {
					id
					name
					slug
					country {
						id
						name
						countryCode
					}
					snowheights {
						updatedAt
						maxSnowValley
						maxSnowMountain
						elevatorsOpen
						elevatorsTotal
					}
				}
			}
		}
	}
`;

export default {
	components: {
		SnowheightBar
	},
	props: {
		coordinates: {
			type: Array,
			default: null
		},
		selectedAreaId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			items: []
		};
	},
	async fetch() {
		await this.$graphClient
			.query({
				query: nearbyQuery,
				variables: {
					coordinates: this.coordinates
				}
			})
			.then(({ data }) => {
				this.items = data.geoInRadius.filter(geo => {
					return geo.area;
				});
			});
	},

	computed: {
		maxSnow() {
			return Math.max(
				...this.items.map(s => {
					return Math.max(
						s.area.snowheights.maxSnowValley,
						s.area.snowheights.maxSnowMountain
					);
				}),
				0
			);
		},

		headers() {
			return [
				{ text: '', value: 'ranking', sortable: false },
				{
					text: this.$t('page.areas._area.snowheight:nearby_table.distance'),
					value: 'distance'
				},
				{
					text: this.$t(
						'page.areas._area.snowheight:nearby_table.snow_mountain'
					),
					value: 'area.snowheights.maxSnowMountain'
				},
				{
					text: this.$t('page.areas._area.snowheight:nearby_table.snow_valley'),
					value: 'area.snowheights.maxSnowValley'
				},
				{
					text: this.$t('page.areas._area.snowheight:nearby_table.open_lifts'),
					value: 'area.snowheights.elevatorsOpen'
				}
			];
		}
	},
	methods: {
		snowNotUpToDate(date) {
			return this.$dayjs().diff(date, 'day') > 7;
		}
	}
};
</script>
